import React, { useContext, useEffect, useState } from "react";
import { allUsers } from "../actions/allUsers";
import { allProperties } from "../actions/allProperties";
import { userDelete } from "../actions/userDelete";
import { propertyDelete } from "../actions/propertyDelete";
import { userAccept } from "../actions/userAccept";
import { userPending } from "../actions/userPending";
import { advertisementPending } from "../actions/advertisementPending";
import { advertisementAccept } from "../actions/advertisementAccept";
import { advertisementDelete } from "../actions/advertisementDelete";
import { advertisementApprove } from "../actions/advertisementApprove";
import { advertisementReject } from "../actions/advertisementReject";
import { getAllAdvertisements } from "../actions/getAllAdvertisements";
import { promotionApprove } from "../actions/promotionApprove";
import { promotionReject } from "../actions/promotionReject";
import { getAllPromotions } from "../actions/getAllPromotions";
import { adminCreatePromotion } from "../actions/adminCreatePromotion";
import { transactionGet } from "../actions/transactionGet";
import { allKeyTransactions } from "../actions/allKeyTransactions";
import { transactionBuy } from "../actions/transactionBuy";
import { transactionSell } from "../actions/transactionSell";
import { transactionDelete } from "../actions/transactionDelete";
import { Link } from "react-router-dom";
import { AlertContext, UserContext } from "../context/MainContext";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import AdminUserEditModal from "../components/AdminUserEditModal";
import ModalEditProperty from "../components/ModalEditProperty";
import AdminAdCreate from "../components/AdminAdCreate";
import { HOST } from "../constants/HostConstants";
import { ENABLE_KEYS } from "../constants/FeatureFlags";
import { commentReportedGet } from "../actions/commentReportedGet";
import { commentApprove } from "../actions/commentApprove";
import { commentApproveBulk } from "../actions/commentApproveBulk";
import { commentClearOrphaned } from "../actions/commentClearOrphaned";
import { commentDeleteAdmin } from "../actions/commentDeleteAdmin";
import { userBan } from "../actions/userBan";
import { advertisementAdminDelete } from "../actions/advertisementAdminDelete";
import { advertisementAdminUpdate } from "../actions/advertisementAdminUpdate";
import { promotionAdminDelete } from "../actions/promotionAdminDelete";
import { adminGiveKeys } from "../actions/adminGiveKeys";
import { adminRevokeKeys } from "../actions/adminRevokeKeys";
import { adminKeyHistory } from "../actions/adminKeyHistory";
import { FaGavel } from "react-icons/fa";

const Admin = () => {
  const [activeTab, setActiveTab] = useState("users"); // "users" | "properties" | "pending" | "ads" | "transactions" | "comments"
  const [users, setUsers] = useState(null);
  const [properties, setProperties] = useState(null);
  const [pending, setPending] = useState(null);
  const [advertisements, setAdvertisements] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [reportedComments, setReportedComments] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState(""); // For properties
  const [filterFor, setFilterFor] = useState(""); // For properties
  const [showUserEditModal, setShowUserEditModal] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const [showPropertyEditModal, setShowPropertyEditModal] = useState(false);
  const [selectedPropertyForEdit, setSelectedPropertyForEdit] = useState(null);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarksContent, setRemarksContent] = useState("");
  const [deleteReason, setDeleteReason] = useState("");
  const [banReason, setBanReason] = useState("");
  const [banningUserId, setBanningUserId] = useState(null);
  const [banningReportId, setBanningReportId] = useState(null);
  const [banningUserEmail, setBanningUserEmail] = useState(null);
  const [banningUserName, setBanningUserName] = useState(null);
  const [banModalSource, setBanModalSource] = useState(null);
  const [treasuryStatus, setTreasuryStatus] = useState(null);
  // Comment delete modal state
  const [showCommentDeleteModal, setShowCommentDeleteModal] = useState(false);
  const [commentToDelete, setCommentToDelete] = useState(null);
  const [commentDeleteReason, setCommentDeleteReason] = useState("");
  // Bulk selection state for reported comments
  const [selectedReports, setSelectedReports] = useState([]);
  // Ad reject modal state
  const [showAdRejectModal, setShowAdRejectModal] = useState(false);
  const [adToReject, setAdToReject] = useState(null);
  const [adRejectReason, setAdRejectReason] = useState("");
  // Ad status filter
  const [adStatusFilter, setAdStatusFilter] = useState("All");
  // Promotion state
  const [promotions, setPromotions] = useState(null);
  const [promotionStatusFilter, setPromotionStatusFilter] = useState("All");
  const [showPromotionRejectModal, setShowPromotionRejectModal] =
    useState(false);
  const [promotionToReject, setPromotionToReject] = useState(null);
  const [promotionRejectReason, setPromotionRejectReason] = useState("");
  // Admin create promotion modal state
  const [showPromotionCreateModal, setShowPromotionCreateModal] =
    useState(false);
  const [promotionUserSearch, setPromotionUserSearch] = useState("");
  const [promotionSelectedUser, setPromotionSelectedUser] = useState(null);
  const [promotionImpressions, setPromotionImpressions] = useState(7500);
  const [promotionCreating, setPromotionCreating] = useState(false);
  // Admin create ad modal state
  const [showAdCreateModal, setShowAdCreateModal] = useState(false);
  // Admin delete ad modal state
  const [showAdDeleteModal, setShowAdDeleteModal] = useState(false);
  const [adToDelete, setAdToDelete] = useState(null);
  const [adDeleteReason, setAdDeleteReason] = useState("");
  // Admin edit ad modal state
  const [showAdEditModal, setShowAdEditModal] = useState(false);
  const [adToEdit, setAdToEdit] = useState(null);
  const [adEditImageUrl, setAdEditImageUrl] = useState("");
  const [adEditLinkUrl, setAdEditLinkUrl] = useState("");
  // Admin delete promotion modal state
  const [showPromoDeleteModal, setShowPromoDeleteModal] = useState(false);
  const [promoToDelete, setPromoToDelete] = useState(null);
  const [promoDeleteReason, setPromoDeleteReason] = useState("");
  // Admin Give/Revoke Keys state
  const [keyGiftUserId, setKeyGiftUserId] = useState("");
  const [keyGiftEmail, setKeyGiftEmail] = useState("");
  const [keyGiftAmount, setKeyGiftAmount] = useState("");
  const [keyGiftReason, setKeyGiftReason] = useState("");
  const [keyGiftMode, setKeyGiftMode] = useState("give"); // "give" | "revoke"
  const [keyGiftProcessing, setKeyGiftProcessing] = useState(false);
  const [keyGiftHistory, setKeyGiftHistory] = useState([]);
  const [keyGiftUserSearch, setKeyGiftUserSearch] = useState("");
  const [keyGiftSelectedUser, setKeyGiftSelectedUser] = useState(null);
  const { setAlert } = useContext(AlertContext);
  const { user } = useContext(UserContext);

  useEffect(() => {
    allUsers(setUsers);
    allProperties({ setProperties });
    userPending({ setPending });
    getAllAdvertisements().then((data) => {
      setAdvertisements(Array.isArray(data) ? data : []);
    });
    getAllPromotions().then((data) => {
      setPromotions(Array.isArray(data) ? data : []);
    });
    allKeyTransactions({ setTransactions });
    // Load reported comments
    commentReportedGet().then((data) => {
      if (Array.isArray(data)) {
        setReportedComments(data);
      } else {
        setReportedComments([]);
      }
    });
    // Load treasury status banner if keys are enabled
    if (ENABLE_KEYS) {
      fetch(`${HOST}/api/user/treasuryStatus`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => setTreasuryStatus(data))
        .catch(() => setTreasuryStatus(null));
    }
  }, []);

  useEffect(() => {
    const handleFocus = () => {
      // Refresh data when user returns to the page
      allProperties({ setProperties }, true); // Force refresh
      allUsers(setUsers);
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, []);
  const handleAcceptUser = async (user_id, email_address) => {
    setAlert(["Approving user", "Please wait...", "waiting"]);
    const result = await userAccept(user_id, email_address, false, {
      setUpdate: () => {},
      setPending,
    });
    if (result?.success) {
      setAlert(["User approved", "The user has been approved.", "confirm"]);
      allUsers(setUsers);
    } else {
      setAlert([
        "Approval failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const handleEditUser = (userItem) => {
    setSelectedUserForEdit(userItem);
    setShowUserEditModal(true);
  };

  const handleUserUpdate = () => {
    allUsers(setUsers);
    setAlert(["User updated", "The user profile has been updated.", "confirm"]);
  };

  const handleDeleteUser = async (user_id, email_address) => {
    if (
      !window.confirm(
        `Remove user: ${email_address}?\n\nNote: Their remaining keys will revert to the Treasury account if configured.`,
      )
    )
      return;
    const reason = window.prompt(
      "Optional: Provide a reason for denial (shown to the user)",
      "",
    );
    setAlert(["Deleting user", "Please wait...", "waiting"]);
    const result = await userDelete(
      user_id,
      email_address,
      { setPending },
      reason,
    );
    if (result?.success) {
      setAlert(["User deleted", "The user has been deleted.", "confirm"]);
      allUsers(setUsers);
    } else {
      setAlert([
        "Delete failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const confirmRemoveUser = (userItem) => {
    setBanningUserId(userItem.user_id);
    setBanningUserEmail(userItem.email_address);
    setBanningUserName(
      `${userItem.legal_first_name} ${userItem.legal_last_name}`,
    );
    setBanModalSource("users");
    setBanReason("");
    setBanningReportId(null);
  };

  const handleEditProperty = (property) => {
    setSelectedPropertyForEdit(property);
    setShowPropertyEditModal(true);
  };

  const handlePropertyUpdate = async () => {
    setShowPropertyEditModal(false);
    setAlert(["Property updated", "Changes saved successfully.", "confirm"]);
    // Force refresh from server
    await new Promise((resolve) => setTimeout(resolve, 500));
    await allProperties({ setProperties }, true);
  };

  const initiateDeleteProperty = (property) => {
    const isOwnProperty = property.user_id === user?.user_id;

    if (isOwnProperty) {
      // For admin's own property, use simple confirmation
      if (
        window.confirm(
          `Are you sure you want to delete property #${property.property_id}?`,
        )
      ) {
        executeDeleteProperty(
          property.property_id,
          property.user_id,
          null,
          null,
        );
      }
    } else {
      // Fetch owner email from user list
      const owner = users?.find((u) => u.user_id === property.user_id);
      const propertyWithEmail = {
        ...property,
        owner_email: owner?.email_address || null,
      };

      // For other users' properties, show modal with reason
      setPropertyToDelete(propertyWithEmail);
      setDeleteReason("");
      setShowDeleteConfirmModal(true);
    }
  };

  const confirmDeleteWithReason = () => {
    if (!deleteReason.trim()) {
      setAlert([
        "Reason required",
        "Please provide a reason for deletion.",
        "failed",
      ]);
      return;
    }
    executeDeleteProperty(
      propertyToDelete.property_id,
      propertyToDelete.user_id,
      propertyToDelete.owner_email,
      deleteReason,
    );
    setShowDeleteConfirmModal(false);
  };

  const executeDeleteProperty = async (
    property_id,
    user_id,
    owner_email,
    reason,
  ) => {
    setAlert(["Deleting property", "Please wait...", "waiting"]);

    try {
      const response = await fetch(`${HOST}/api/property/propertyDelete`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          property_id,
          user_id,
          owner_email,
          reason,
          admin_user_id: user?.user_id,
          admin_email: user?.email_address,
        }),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (response.ok) {
        // Force refresh from server
        await new Promise((resolve) => setTimeout(resolve, 500));
        await allProperties({ setProperties }, true);
        setAlert([
          "Property deleted",
          "The property has been deleted.",
          "confirm",
        ]);
      } else {
        setAlert([
          "Delete failed",
          data.error || "Unexpected error.",
          "failed",
        ]);
      }
    } catch (error) {
      setAlert(["Delete failed", error.message, "failed"]);
    }
  };
  const handleAcceptAdvertisement = async (
    advertisement_id,
    user_id,
    email_address,
  ) => {
    setAlert(["Approving advertisement", "Please wait...", "waiting"]);
    const result = await advertisementAccept(
      advertisement_id,
      user_id,
      setAdvertisements,
      email_address,
    );
    if (result?.success) {
      setAlert(["Advertisement approved", "Ad has been approved.", "confirm"]);
    } else {
      setAlert([
        "Approval failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };
  const handleDeleteAd = async (advertisement_id, user_id, email_address) => {
    setAlert(["Deleting advertisement", "Please wait...", "waiting"]);
    const result = await advertisementDelete(
      advertisement_id,
      user_id,
      setAdvertisements,
      email_address,
    );
    if (result?.success) {
      setAlert(["Advertisement deleted", "Ad has been removed.", "confirm"]);
    } else {
      setAlert([
        "Delete failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const handleApproveNewAd = async (advertisement_id) => {
    setAlert(["Approving advertisement", "Please wait...", "waiting"]);
    try {
      const result = await advertisementApprove(advertisement_id);
      if (result?.success) {
        setAlert(["Advertisement approved", "Ad is now live.", "confirm"]);
        // Refresh all ads to show updated status
        const allAds = await getAllAdvertisements();
        setAdvertisements(allAds);
      }
    } catch (error) {
      setAlert([
        "Approval failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const handleRejectAd = async () => {
    if (!adRejectReason.trim()) {
      setAlert([
        "Reason required",
        "Please provide a reason for rejection.",
        "failed",
      ]);
      return;
    }

    setAlert(["Rejecting advertisement", "Please wait...", "waiting"]);
    try {
      const result = await advertisementReject(
        adToReject.advertisement_id,
        adRejectReason,
      );
      if (result?.success) {
        setAlert([
          "Advertisement rejected",
          "Keys have been refunded to the user.",
          "confirm",
        ]);
        setShowAdRejectModal(false);
        setAdToReject(null);
        setAdRejectReason("");
        // Refresh all ads
        const allAds = await getAllAdvertisements();
        setAdvertisements(allAds);
      }
    } catch (error) {
      setAlert([
        "Rejection failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const openAdRejectModal = (ad) => {
    setAdToReject(ad);
    setAdRejectReason("");
    setShowAdRejectModal(true);
  };

  const handleApprovePromotion = async (promotion_id) => {
    setAlert(["Approving promotion", "Please wait...", "waiting"]);
    try {
      const result = await promotionApprove(promotion_id);
      if (result?.success) {
        setAlert([
          "Profile promotion approved",
          "Promotion is now active.",
          "confirm",
        ]);
        // Refresh all promotions
        const allPromotions = await getAllPromotions();
        setPromotions(Array.isArray(allPromotions) ? allPromotions : []);
      }
    } catch (error) {
      setAlert([
        "Approval failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const handleRejectPromotion = async () => {
    if (!promotionRejectReason.trim()) {
      setAlert([
        "Reason required",
        "Please provide a reason for rejection.",
        "failed",
      ]);
      return;
    }

    setAlert(["Rejecting promotion", "Please wait...", "waiting"]);
    try {
      const result = await promotionReject(
        promotionToReject.promotion_id,
        promotionToReject.user_id,
        promotionRejectReason,
      );
      if (result?.success) {
        setAlert([
          "Profile promotion rejected",
          "Keys have been refunded to the user.",
          "confirm",
        ]);
        setShowPromotionRejectModal(false);
        setPromotionToReject(null);
        setPromotionRejectReason("");
        // Refresh all promotions
        const allPromotions = await getAllPromotions();
        setPromotions(Array.isArray(allPromotions) ? allPromotions : []);
      }
    } catch (error) {
      setAlert([
        "Rejection failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const openPromotionRejectModal = (promotion) => {
    setPromotionToReject(promotion);
    setPromotionRejectReason("");
    setShowPromotionRejectModal(true);
  };

  // --- Admin Delete Ad ---
  const openAdDeleteModal = (ad) => {
    setAdToDelete(ad);
    setAdDeleteReason("");
    setShowAdDeleteModal(true);
  };
  const handleAdminDeleteAd = async () => {
    if (!adDeleteReason.trim()) {
      setAlert([
        "Reason required",
        "Please provide a reason for deletion.",
        "failed",
      ]);
      return;
    }
    setAlert(["Deleting advertisement", "Please wait...", "waiting"]);
    try {
      const result = await advertisementAdminDelete(
        adToDelete.advertisement_id,
        adDeleteReason,
      );
      if (result?.success) {
        setAlert([
          "Advertisement deleted",
          "The ad has been permanently removed.",
          "confirm",
        ]);
        setShowAdDeleteModal(false);
        setAdToDelete(null);
        setAdDeleteReason("");
        const allAds = await getAllAdvertisements();
        setAdvertisements(allAds);
      }
    } catch (error) {
      setAlert([
        "Delete failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  // --- Admin Edit Ad ---
  const openAdEditModal = (ad) => {
    setAdToEdit(ad);
    setAdEditImageUrl(ad.advertisement_url || "");
    setAdEditLinkUrl(ad.link_url || "");
    setShowAdEditModal(true);
  };
  const handleAdminEditAd = async () => {
    const newImage =
      adEditImageUrl.trim() !== adToEdit.advertisement_url
        ? adEditImageUrl.trim()
        : null;
    const newLink =
      adEditLinkUrl.trim() !== adToEdit.link_url ? adEditLinkUrl.trim() : null;
    if (!newImage && !newLink) {
      setAlert(["No changes", "Nothing was changed.", "failed"]);
      return;
    }
    setAlert(["Updating advertisement", "Please wait...", "waiting"]);
    try {
      const result = await advertisementAdminUpdate(
        adToEdit.advertisement_id,
        newImage || undefined,
        newLink || undefined,
      );
      if (result?.success) {
        setAlert(["Advertisement updated", "Changes saved.", "confirm"]);
        setShowAdEditModal(false);
        setAdToEdit(null);
        const allAds = await getAllAdvertisements();
        setAdvertisements(allAds);
      }
    } catch (error) {
      setAlert([
        "Update failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  // --- Admin Delete Promotion ---
  const openPromoDeleteModal = (promo) => {
    setPromoToDelete(promo);
    setPromoDeleteReason("");
    setShowPromoDeleteModal(true);
  };
  const handleAdminDeletePromotion = async () => {
    if (!promoDeleteReason.trim()) {
      setAlert([
        "Reason required",
        "Please provide a reason for deletion.",
        "failed",
      ]);
      return;
    }
    setAlert(["Deleting promotion", "Please wait...", "waiting"]);
    try {
      const result = await promotionAdminDelete(
        promoToDelete.promotion_id,
        promoDeleteReason,
      );
      if (result?.success) {
        setAlert([
          "Promotion deleted",
          "The promotion has been permanently removed.",
          "confirm",
        ]);
        setShowPromoDeleteModal(false);
        setPromoToDelete(null);
        setPromoDeleteReason("");
        const allPromotions = await getAllPromotions();
        setPromotions(Array.isArray(allPromotions) ? allPromotions : []);
      }
    } catch (error) {
      setAlert([
        "Delete failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    }
  };

  const handleAdminCreatePromotion = async () => {
    if (!promotionSelectedUser) {
      setAlert([
        "No user selected",
        "Please search and select a user.",
        "failed",
      ]);
      return;
    }
    setPromotionCreating(true);
    setAlert(["Creating promotion", "Please wait...", "waiting"]);
    try {
      const result = await adminCreatePromotion(
        promotionSelectedUser.user_id,
        promotionImpressions,
      );
      if (result?.success) {
        setAlert([
          "Promotion created",
          `Active promotion set for ${promotionSelectedUser.legal_first_name} ${promotionSelectedUser.legal_last_name}.`,
          "confirm",
        ]);
        setShowPromotionCreateModal(false);
        setPromotionSelectedUser(null);
        setPromotionUserSearch("");
        setPromotionImpressions(7500);
        const allPromotions = await getAllPromotions();
        setPromotions(Array.isArray(allPromotions) ? allPromotions : []);
      }
    } catch (error) {
      setAlert([
        "Creation failed",
        error.message || "Unexpected error.",
        "failed",
      ]);
    } finally {
      setPromotionCreating(false);
    }
  };

  const handleAcceptTransaction = async (
    transaction_id,
    user_id,
    email_address,
    amount,
    option,
  ) => {
    setAlert(["Processing transaction", "Please wait...", "waiting"]);
    const result =
      option === "Buy"
        ? await transactionBuy(transaction_id, user_id, email_address, amount, {
            setTransactions,
          })
        : await transactionSell(
            transaction_id,
            user_id,
            email_address,
            amount,
            { setTransactions },
          );
    if (result?.success) {
      setAlert([
        "Transaction processed",
        "Status updated successfully.",
        "confirm",
      ]);
    } else {
      setAlert([
        "Transaction failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };
  const handleDeleteTransaction = async (
    transaction_id,
    user_id,
    email_address,
    amount,
    option,
  ) => {
    setAlert(["Deleting transaction", "Please wait...", "waiting"]);
    const result = await transactionDelete(
      transaction_id,
      user_id,
      email_address,
      amount,
      {
        setTransactions,
      },
    );
    if (result?.success) {
      setAlert([
        "Transaction deleted",
        "The transaction has been removed.",
        "confirm",
      ]);
    } else {
      setAlert([
        "Delete failed",
        result?.error || "Unexpected error.",
        "failed",
      ]);
    }
  };

  // Admin Give/Revoke Keys handlers
  const handleKeyGiftSelectUser = (u) => {
    setKeyGiftSelectedUser(u);
    setKeyGiftUserId(u.user_id);
    setKeyGiftEmail(u.email_address);
    setKeyGiftUserSearch("");
  };

  const handleKeyGiftSubmit = async () => {
    if (!keyGiftUserId || !keyGiftEmail || !keyGiftAmount) {
      setAlert([
        "Missing fields",
        "Please fill in all required fields.",
        "failed",
      ]);
      return;
    }
    const amt = Number(keyGiftAmount);
    if (isNaN(amt) || amt <= 0) {
      setAlert([
        "Invalid amount",
        "Please enter a positive number of keys.",
        "failed",
      ]);
      return;
    }

    setKeyGiftProcessing(true);
    setAlert([
      keyGiftMode === "give" ? "Giving keys..." : "Revoking keys...",
      "Please wait...",
      "waiting",
    ]);

    try {
      const result =
        keyGiftMode === "give"
          ? await adminGiveKeys(keyGiftUserId, keyGiftEmail, amt, keyGiftReason)
          : await adminRevokeKeys(
              keyGiftUserId,
              keyGiftEmail,
              amt,
              keyGiftReason,
            );

      if (result?.success) {
        setAlert([
          keyGiftMode === "give" ? "Keys Given" : "Keys Revoked",
          `${amt} keys ${keyGiftMode === "give" ? "given to" : "revoked from"} ${keyGiftEmail}`,
          "confirm",
        ]);
        // Reset form
        setKeyGiftUserId("");
        setKeyGiftEmail("");
        setKeyGiftAmount("");
        setKeyGiftReason("");
        setKeyGiftSelectedUser(null);
        // Refresh history and users
        loadKeyGiftHistory();
        allUsers(setUsers);
      } else {
        setAlert([
          "Operation failed",
          result?.error || "Unexpected error.",
          "failed",
        ]);
      }
    } catch (err) {
      setAlert(["Error", err.message || "Unexpected error.", "failed"]);
    } finally {
      setKeyGiftProcessing(false);
    }
  };

  const loadKeyGiftHistory = async () => {
    const result = await adminKeyHistory();
    if (result?.success) {
      setKeyGiftHistory(result.data);
    }
  };

  function currencyFormat(num) {
    if (!num) return "$0";
    let money = "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    return money.substring(0, money.length - 3);
  }

  const filteredUsers = users?.filter((u) =>
    searchQuery
      ? (u.email_address || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (u.legal_first_name || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (u.legal_last_name || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      : true,
  );

  const filteredProperties = properties?.filter((p) => {
    const keywordMatch = searchQuery
      ? String(p.property_id || "").includes(searchQuery) ||
        (p.street_name || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (p.city || "").toLowerCase().includes(searchQuery.toLowerCase())
      : true;
    const typeMatch = filterType ? (p.type || "") === filterType : true;
    const forMatch = filterFor ? (p.for || "") === filterFor : true;
    return keywordMatch && typeMatch && forMatch;
  });

  return (
    <div className="max-w-[1800px] mx-auto px-4 py-12 mt-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Admin Panel</h1>
      </div>

      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        <button
          onClick={() => setActiveTab("users")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "users"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          All Users ({users?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("properties")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "properties"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          All Properties ({properties?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("pending")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "pending"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          Pending Users ({pending?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("ads")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "ads"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          Advertisements ({advertisements?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("transactions")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "transactions"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          Transactions ({transactions?.length || 0})
        </button>
        <button
          onClick={() => setActiveTab("comments")}
          className={`px-6 py-3 rounded-lg transition-all font-medium ${
            activeTab === "comments"
              ? "bg-blue-600 text-white"
              : "bg-slate-300 text-gray-700 hover:bg-slate-400"
          }`}
        >
          Reported Comments ({reportedComments?.length || 0})
        </button>
        {ENABLE_KEYS && (
          <button
            onClick={() => {
              setActiveTab("keys");
              loadKeyGiftHistory();
            }}
            className={`px-6 py-3 rounded-lg transition-all font-medium ${
              activeTab === "keys"
                ? "bg-amber-600 text-white"
                : "bg-slate-300 text-gray-700 hover:bg-slate-400"
            }`}
          >
            🔑 Give Keys
          </button>
        )}
      </div>

      {/* Search and Filters */}
      {(activeTab === "users" || activeTab === "properties") && (
        <div className="bg-white p-4 rounded-lg shadow-md border border-gray-200 mb-6">
          <div className="flex flex-wrap gap-3">
            <input
              type="text"
              placeholder={
                activeTab === "users"
                  ? "Search users by name or email..."
                  : "Search properties by ID, address, or city..."
              }
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="flex-1 min-w-[250px] px-4 py-2 border border-gray-300 rounded-lg"
            />
            {activeTab === "properties" && (
              <>
                <select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg"
                >
                  <option value="">All Types</option>
                  <option value="Residential">Residential</option>
                  <option value="Commercial">Commercial</option>
                </select>
                <select
                  value={filterFor}
                  onChange={(e) => setFilterFor(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg"
                >
                  <option value="">For Sale/Lease</option>
                  <option value="Sale">For Sale</option>
                  <option value="Lease">For Lease</option>
                </select>
                <button
                  onClick={() => {
                    setSearchQuery("");
                    setFilterType("");
                    setFilterFor("");
                  }}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
                >
                  Clear
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* Users Tab */}
      {activeTab === "users" && (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          {ENABLE_KEYS && treasuryStatus?.enableKeys && (
            <div className="bg-yellow-50 border-b border-yellow-200 px-4 py-2 text-sm text-yellow-800">
              Treasury revert is enabled
            </div>
          )}
          <div className="flex justify-between items-center p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">
              All Registered Users
            </h2>
            <button
              onClick={() => {
                allUsers(setUsers);
                setTimeout(
                  () =>
                    setAlert([
                      "Users refreshed",
                      "Data has been updated.",
                      "confirm",
                    ]),
                  500,
                );
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
            >
              Refresh
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    User ID
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Email
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Name
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Profession
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Keys
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Properties
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers?.map((userItem, index) => {
                  const isCurrentUser = userItem.user_id === user?.user_id;
                  return (
                    <tr
                      key={userItem.user_id}
                      className={`${
                        isCurrentUser
                          ? "bg-blue-50 border-2 border-blue-300"
                          : index % 2 === 0
                            ? "bg-white"
                            : "bg-gray-50"
                      }`}
                    >
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          {userItem.user_id}
                          {isCurrentUser && (
                            <span className="bg-blue-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
                              YOU
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <Link
                          to={`/user/${userItem.user_id}`}
                          className="text-blue-600 hover:underline"
                        >
                          {userItem.email_address}
                        </Link>
                      </td>
                      <td className="px-4 py-3">
                        {userItem.legal_first_name} {userItem.legal_last_name}
                      </td>
                      <td className="px-4 py-3">
                        {userItem.class_type || "N/A"}
                      </td>
                      <td className="px-4 py-3 text-center font-semibold">
                        {userItem.keys || 0}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {properties?.filter(
                          (p) => p.user_id === userItem.user_id,
                        ).length || 0}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => handleEditUser(userItem)}
                            className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 transition-colors"
                            title="Edit User Profile"
                          >
                            Edit
                          </button>
                          <Link
                            to={`/user/${userItem.user_id}`}
                            className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                            title="View Public Profile"
                            target="_blank"
                          >
                            View
                          </Link>
                          {!isCurrentUser && (
                            <button
                              onClick={() => confirmRemoveUser(userItem)}
                              className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors flex items-center gap-1"
                              title="Ban User"
                            >
                              <FaGavel className="text-sm" />
                              Ban
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {filteredUsers?.length === 0 && (
            <p className="text-center py-8 text-gray-500">No users found.</p>
          )}
        </div>
      )}

      {/* Properties Tab */}
      {activeTab === "properties" && (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="bg-blue-50 border-b border-blue-200 px-4 py-3 flex justify-between items-center">
            <p className="text-sm text-blue-800 font-medium">
              Showing all properties from all users across the platform (
              {properties?.length || 0} total)
            </p>
            <button
              onClick={() => {
                setAlert([
                  "Refreshing properties",
                  "Please wait...",
                  "waiting",
                ]);
                allProperties({ setProperties }, true); // Force refresh, clear cache
                setTimeout(
                  () =>
                    setAlert([
                      "Properties refreshed",
                      "Data has been updated.",
                      "confirm",
                    ]),
                  500,
                );
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
            >
              Refresh
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    ID
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Image
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Address
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Type
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    For
                  </th>
                  <th className="px-4 py-3 text-right font-semibold text-gray-700">
                    Price
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Views
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Owner
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredProperties?.map((property, index) => {
                  const isOwnProperty = property.user_id === user?.user_id;
                  const isSold = property.property_status === "Sold";
                  const rowClass = isOwnProperty
                    ? "bg-green-50 border-2 border-green-300"
                    : isSold
                      ? "bg-red-50 border-2 border-red-300"
                      : index % 2 === 0
                        ? "bg-white"
                        : "bg-gray-50";

                  return (
                    <tr key={property.property_id} className={`${rowClass}`}>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded text-xs font-semibold ${
                            property.property_status === "Active"
                              ? "bg-green-100 text-green-800"
                              : property.property_status === "Sold"
                                ? "bg-red-100 text-red-800"
                                : property.property_status === "Leased"
                                  ? "bg-blue-100 text-blue-800"
                                  : "bg-gray-100 text-gray-800"
                          }`}
                        >
                          {property.property_status}
                        </span>
                      </td>
                      <td className="px-4 py-3 font-mono">
                        {property.property_id}
                      </td>
                      <td className="px-4 py-3">
                        <img
                          src={cloudinaryUrl(property.media_url?.split(",")[0])}
                          alt=""
                          className="w-16 h-12 object-cover rounded"
                        />
                      </td>
                      <td className="px-4 py-3">
                        <Link
                          to={`/property/${property.property_id}`}
                          className="text-blue-600 hover:underline"
                        >
                          {property.street_number} {property.street_name},{" "}
                          {property.city}
                        </Link>
                      </td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded text-xs ${
                            property.type === "Residential"
                              ? "bg-blue-100 text-blue-800"
                              : "bg-purple-100 text-purple-800"
                          }`}
                        >
                          {property.type || "N/A"}
                        </span>
                      </td>
                      <td className="px-4 py-3">{property.for || "N/A"}</td>
                      <td className="px-4 py-3 text-right font-semibold">
                        {currencyFormat(property.price)}
                        {property.for === "Lease" && "/mo"}
                      </td>
                      <td className="px-4 py-3 text-center">
                        {property.impressions || 0}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <Link
                            to={`/user/${property.user_id}`}
                            className="text-blue-600 hover:underline text-xs"
                          >
                            User #{property.user_id}
                          </Link>
                          {isOwnProperty && (
                            <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
                              YOURS
                            </span>
                          )}
                          {isSold && (
                            <span className="bg-red-600 text-white text-xs px-2 py-1 rounded-full font-semibold">
                              SOLD
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex justify-center gap-2">
                          <Link
                            to={`/property/${property.property_id}`}
                            className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 transition-colors"
                            title="View Property"
                          >
                            View
                          </Link>
                          <button
                            onClick={() => handleEditProperty(property)}
                            className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                            title="Edit Property"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => initiateDeleteProperty(property)}
                            className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors"
                            title="Delete Property"
                          >
                            Delete
                          </button>
                          {(user?.class_type === "Realtor" ||
                            user?.class_type === "Broker" ||
                            user?.class_type === "Admin") && (
                            <button
                              onClick={() => {
                                setRemarksContent(
                                  property.agent_remarks ||
                                    "No agent remarks available.",
                                );
                                setShowRemarksModal(true);
                              }}
                              className="bg-indigo-600 text-white px-3 py-1 rounded text-xs hover:bg-indigo-700 transition-colors"
                              title="View Agent Remarks"
                            >
                              View Agent Remarks
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {filteredProperties?.length === 0 && (
            <p className="text-center py-8 text-gray-500">
              No properties found.
            </p>
          )}
        </div>
      )}

      {/* Pending Users Tab */}
      {activeTab === "pending" && (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">
              Pending User Registrations
            </h2>
            <button
              onClick={() => {
                userPending({ setPending });
                setTimeout(
                  () =>
                    setAlert([
                      "Pending users refreshed",
                      "Data has been updated.",
                      "confirm",
                    ]),
                  500,
                );
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
            >
              Refresh
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Email Address
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Full Name
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Profession
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    License/Prof ID
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Phone Number
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Business Name
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Position
                  </th>
                  {/* NEW: Phase 1 Profession-Specific Columns */}
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 text-xs">
                    NAR / BR
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700 text-xs">
                    Details
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Username
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Registered
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {pending?.map((account, index) => (
                  <tr
                    key={account.user_id}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-4 py-3">
                      {account.email_address || "N/A"}
                    </td>
                    <td className="px-4 py-3">
                      {account.legal_first_name || ""}{" "}
                      {account.legal_last_name || ""}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`px-2 py-1 rounded text-xs font-semibold ${
                          account.class_type === "Realtor"
                            ? "bg-blue-100 text-blue-800"
                            : account.class_type === "Lender"
                              ? "bg-green-100 text-green-800"
                              : account.class_type === "Title Company"
                                ? "bg-purple-100 text-purple-800"
                                : account.class_type === "Builder"
                                  ? "bg-orange-100 text-orange-800"
                                  : account.class_type === "Broker"
                                    ? "bg-red-100 text-red-800"
                                    : account.class_type === "Advertiser"
                                      ? "bg-yellow-100 text-yellow-800"
                                      : "bg-gray-100 text-gray-800"
                        }`}
                      >
                        {account.class_type || "N/A"}
                      </span>
                    </td>
                    <td className="px-4 py-3 font-mono text-xs">
                      {account.profession_id || "—"}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {account.phone_number || "—"}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {account.business_name || "—"}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {account.position || "—"}
                    </td>
                    {/* NEW: Phase 1 Profession-Specific Data */}
                    <td className="px-4 py-3 text-xs">
                      {account.class_type === "Realtor" ? (
                        <div className="space-y-0.5">
                          <div>NAR: {account.is_realtor ? "✓" : "✗"}</div>
                          {account.is_realtor && (
                            <div>BR: {account.is_broker ? "✓" : "✗"}</div>
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {account.class_type === "Builder" ? (
                        <div className="space-y-0.5">
                          {account.builder_number && (
                            <div>B#: {account.builder_number}</div>
                          )}
                          {account.builder_email && (
                            <div className="truncate">
                              {account.builder_email}
                            </div>
                          )}
                        </div>
                      ) : account.class_type === "Title Company" ? (
                        <div className="space-y-0.5">
                          {account.title_company_name && (
                            <div className="truncate">
                              {account.title_company_name}
                            </div>
                          )}
                          {account.title_company_phone && (
                            <div className="text-xs">
                              {account.title_company_phone}
                            </div>
                          )}
                        </div>
                      ) : account.class_type === "Lender" ? (
                        <div className="space-y-0.5">
                          {account.company_license_number && (
                            <div>Co#: {account.company_license_number}</div>
                          )}
                          {account.supervisor_name && (
                            <div className="truncate">
                              {account.supervisor_name}
                            </div>
                          )}
                        </div>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {account.username || "—"}
                    </td>
                    <td className="px-4 py-3 text-xs text-gray-500">
                      {account.listed_date || "—"}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() =>
                            handleAcceptUser(
                              account.user_id,
                              account.email_address,
                            )
                          }
                          className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                          title="Approve user"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteUser(
                              account.user_id,
                              account.email_address,
                            )
                          }
                          className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors"
                          title="Deny and delete user"
                        >
                          Deny
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {pending?.length === 0 && (
            <p className="text-center py-8 text-gray-500">No pending users.</p>
          )}
        </div>
      )}

      {/* Advertisements Tab */}
      {activeTab === "ads" && (
        <div>
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 flex-wrap gap-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-800">
                  All Advertisements
                </h2>
                <p className="text-sm text-gray-500">
                  Total: {advertisements?.length || 0}
                </p>
              </div>
              <div className="flex gap-2 flex-wrap">
                <select
                  value={adStatusFilter}
                  onChange={(e) => setAdStatusFilter(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm"
                >
                  <option value="All">All Statuses</option>
                  <option value="Pending">Pending Approval</option>
                  <option value="Active">Active</option>
                  <option value="Rejected">Rejected</option>
                </select>
                <button
                  onClick={() => {
                    getAllAdvertisements().then((data) => {
                      setAdvertisements(Array.isArray(data) ? data : []);
                    });
                    setTimeout(
                      () =>
                        setAlert([
                          "Advertisements refreshed",
                          "Data has been updated.",
                          "confirm",
                        ]),
                      500,
                    );
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
                >
                  Refresh
                </button>
                <button
                  onClick={() => setShowAdCreateModal(true)}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
                  title="Create a new advertisement"
                >
                  + Create Ad
                </button>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Ad ID
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      User / Email
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Format
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Preview
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Link
                    </th>
                    <th className="px-4 py-3 text-right font-semibold text-gray-700">
                      Impressions
                    </th>
                    <th className="px-4 py-3 text-center font-semibold text-gray-700">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {advertisements
                    ?.filter((ad) =>
                      adStatusFilter === "All"
                        ? true
                        : ad.advertisement_status === adStatusFilter,
                    )
                    .map((advertisement, index) => (
                      <tr
                        key={advertisement.advertisement_id}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td className="px-4 py-3 font-mono text-xs">
                          {advertisement.advertisement_id}
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${
                              advertisement.advertisement_status === "Pending"
                                ? "bg-yellow-100 text-yellow-800"
                                : advertisement.advertisement_status ===
                                    "Active"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-red-100 text-red-800"
                            }`}
                          >
                            {advertisement.advertisement_status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-sm">
                          <div>
                            <div className="font-medium">
                              User #{advertisement.user_id}
                            </div>
                            <div className="text-xs text-gray-600">
                              {advertisement.email_address || "N/A"}
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="text-sm">
                            <div className="capitalize font-medium">
                              {advertisement.alignment}
                            </div>
                            <div className="text-xs text-gray-600">
                              {advertisement.format_width}x
                              {advertisement.format_height}px
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <a
                            className="text-blue-600 hover:underline text-sm"
                            href={cloudinaryUrl(
                              advertisement.advertisement_url,
                            )}
                            target="_blank"
                            rel="noreferrer"
                          >
                            View Image
                          </a>
                        </td>
                        <td className="px-4 py-3">
                          <a
                            href={advertisement.link_url}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-600 hover:underline text-xs truncate max-w-[200px] block"
                            title={advertisement.link_url}
                          >
                            {advertisement.link_url}
                          </a>
                        </td>
                        <td className="px-4 py-3 text-right font-semibold">
                          {advertisement.impressions || 0}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex justify-center gap-2 flex-wrap">
                            {advertisement.advertisement_status ===
                              "Pending" && (
                              <>
                                <button
                                  onClick={() =>
                                    handleApproveNewAd(
                                      advertisement.advertisement_id,
                                    )
                                  }
                                  className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                                  title="Approve advertisement"
                                >
                                  Approve
                                </button>
                                <button
                                  onClick={() =>
                                    openAdRejectModal(advertisement)
                                  }
                                  className="bg-yellow-600 text-white px-3 py-1 rounded text-xs hover:bg-yellow-700 transition-colors"
                                  title="Reject and refund"
                                >
                                  Reject
                                </button>
                              </>
                            )}
                            <button
                              onClick={() => openAdEditModal(advertisement)}
                              className="bg-blue-600 text-white px-3 py-1 rounded text-xs hover:bg-blue-700 transition-colors"
                              title="Edit image or link"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => openAdDeleteModal(advertisement)}
                              className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors"
                              title="Delete advertisement"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {advertisements?.filter((ad) =>
              adStatusFilter === "All"
                ? true
                : ad.advertisement_status === adStatusFilter,
            ).length === 0 && (
              <p className="text-center py-8 text-gray-500">
                No{" "}
                {adStatusFilter !== "All"
                  ? `${adStatusFilter.toLowerCase()} `
                  : ""}
                advertisements found.
              </p>
            )}
          </div>

          {/* Profile Promotions Section */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden mt-8">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 flex-wrap gap-4">
              <div>
                <h2 className="text-lg font-semibold text-gray-800">
                  Profile Promotions
                </h2>
                <p className="text-sm text-gray-500">
                  Total: {promotions?.length || 0}
                </p>
              </div>
              <div className="flex gap-2 flex-wrap">
                <select
                  value={promotionStatusFilter}
                  onChange={(e) => setPromotionStatusFilter(e.target.value)}
                  className="px-4 py-2 border border-gray-300 rounded-lg text-sm"
                >
                  <option value="All">All Statuses</option>
                  <option value="Pending">Pending Approval</option>
                  <option value="Active">Active</option>
                  <option value="Rejected">Rejected</option>
                </select>
                <button
                  onClick={() => {
                    getAllPromotions().then((data) => {
                      setPromotions(Array.isArray(data) ? data : []);
                    });
                    setTimeout(
                      () =>
                        setAlert([
                          "Promotions refreshed",
                          "Data has been updated.",
                          "confirm",
                        ]),
                      500,
                    );
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
                >
                  Refresh
                </button>
                <button
                  onClick={() => {
                    setShowPromotionCreateModal(true);
                    setPromotionSelectedUser(null);
                    setPromotionUserSearch("");
                    setPromotionImpressions(7500);
                  }}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
                >
                  + Add Promotion
                </button>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Promo ID
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      User Name
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Email
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Company
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Position
                    </th>
                    <th className="px-4 py-3 text-right font-semibold text-gray-700">
                      Impressions
                    </th>
                    <th className="px-4 py-3 text-center font-semibold text-gray-700">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {promotions
                    ?.filter((promo) =>
                      promotionStatusFilter === "All"
                        ? true
                        : promo.status === promotionStatusFilter,
                    )
                    .map((promotion, index) => (
                      <tr
                        key={promotion.promotion_id}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                      >
                        <td className="px-4 py-3 font-mono text-xs">
                          {promotion.promotion_id}
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${
                              promotion.status === "Pending"
                                ? "bg-yellow-100 text-yellow-800"
                                : promotion.status === "Active"
                                  ? "bg-green-100 text-green-800"
                                  : "bg-red-100 text-red-800"
                            }`}
                          >
                            {promotion.status}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="font-medium">
                            {promotion.legal_first_name}{" "}
                            {promotion.legal_last_name}
                          </div>
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-600">
                          {promotion.email_address || "N/A"}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {promotion.business_name || "N/A"}
                        </td>
                        <td className="px-4 py-3 text-sm">
                          {promotion.position || "N/A"}
                        </td>
                        <td className="px-4 py-3 text-right">
                          <div className="text-sm font-semibold">
                            {promotion.impressions_current}/
                            {promotion.impressions_limit}
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1">
                            <div
                              className="bg-purple-600 h-1.5 rounded-full"
                              style={{
                                width: `${Math.min((promotion.impressions_current / promotion.impressions_limit) * 100, 100)}%`,
                              }}
                            />
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex justify-center gap-2 flex-wrap">
                            {promotion.status === "Pending" && (
                              <>
                                <button
                                  onClick={() =>
                                    handleApprovePromotion(
                                      promotion.promotion_id,
                                    )
                                  }
                                  className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                                  title="Approve promotion"
                                >
                                  Approve
                                </button>
                                <button
                                  onClick={() =>
                                    openPromotionRejectModal(promotion)
                                  }
                                  className="bg-yellow-600 text-white px-3 py-1 rounded text-xs hover:bg-yellow-700 transition-colors"
                                  title="Reject and refund"
                                >
                                  Reject
                                </button>
                              </>
                            )}
                            <button
                              onClick={() => openPromoDeleteModal(promotion)}
                              className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors"
                              title="Delete promotion"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {promotions?.filter((promo) =>
              promotionStatusFilter === "All"
                ? true
                : promo.status === promotionStatusFilter,
            ).length === 0 && (
              <p className="text-center py-8 text-gray-500">
                No{" "}
                {promotionStatusFilter !== "All"
                  ? `${promotionStatusFilter.toLowerCase()} `
                  : ""}
                profile promotions found.
              </p>
            )}
          </div>
        </div>
      )}
      {activeTab === "transactions" && (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">
              Key Transactions
            </h2>
            <button
              onClick={() => {
                allKeyTransactions({ setTransactions });
                setTimeout(
                  () =>
                    setAlert([
                      "Transactions refreshed",
                      "Data has been updated.",
                      "confirm",
                    ]),
                  500,
                );
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
            >
              Refresh
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-100 border-b border-gray-200">
                <tr>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Transaction ID
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    User ID
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Email Address
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Option
                  </th>
                  <th className="px-4 py-3 text-right font-semibold text-gray-700">
                    Amount
                  </th>
                  <th className="px-4 py-3 text-left font-semibold text-gray-700">
                    Status
                  </th>
                  <th className="px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                  {(user?.class_type === "Realtor" ||
                    user?.class_type === "Broker" ||
                    user?.class_type === "Admin") && (
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Agent Remarks
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {transactions?.map((transaction, index) => (
                  <tr
                    key={transaction.transaction_id}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="px-4 py-3">
                      {transaction.transaction_id || "N/A"}
                    </td>
                    <td className="px-4 py-3">
                      {transaction.user_id || "N/A"}
                    </td>
                    <td className="px-4 py-3">
                      {transaction.email_address || "N/A"}
                    </td>
                    <td className="px-4 py-3">{transaction.option || "N/A"}</td>
                    <td className="px-4 py-3 text-right font-semibold">
                      {currencyFormat(transaction.amount)}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`px-2 py-1 rounded text-xs ${
                          transaction.status === "Pending"
                            ? "bg-yellow-100 text-yellow-800"
                            : "bg-green-100 text-green-800"
                        }`}
                      >
                        {transaction.status || "N/A"}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex justify-center gap-2">
                        <button
                          onClick={() =>
                            handleAcceptTransaction(
                              transaction.transaction_id,
                              transaction.user_id,
                              transaction.email_address,
                              transaction.amount,
                              transaction.option,
                            )
                          }
                          className="bg-green-600 text-white px-3 py-1 rounded text-xs hover:bg-green-700 transition-colors"
                          title="Approve transaction"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() =>
                            handleDeleteTransaction(
                              transaction.transaction_id,
                              transaction.user_id,
                              transaction.email_address,
                              transaction.amount,
                              transaction.option,
                            )
                          }
                          className="bg-red-600 text-white px-3 py-1 rounded text-xs hover:bg-red-700 transition-colors"
                          title="Deny transaction"
                        >
                          Deny
                        </button>
                      </div>
                    </td>
                    {(user?.class_type === "Realtor" ||
                      user?.class_type === "Broker" ||
                      user?.class_type === "Admin") && (
                      <td className="px-4 py-3">
                        <div className="max-w-[300px] text-sm text-slate-800 break-words">
                          {transaction.agent_remarks || "—"}
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {transactions?.length === 0 && (
            <p className="text-center py-8 text-gray-500">
              No pending transactions.
            </p>
          )}
        </div>
      )}

      {/* Give/Revoke Keys Tab */}
      {activeTab === "keys" && (
        <div className="space-y-6">
          {/* Give/Revoke Form */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-800 mb-1">
                {keyGiftMode === "give"
                  ? "🔑 Give Keys to User"
                  : "↩️ Revoke Keys from User"}
              </h2>
              <p className="text-sm text-gray-500">
                {keyGiftMode === "give"
                  ? "Keys are deducted from the Treasury and added to the user's balance."
                  : "Keys are removed from the user's balance and returned to the Treasury."}
              </p>
            </div>
            <div className="p-6 space-y-5">
              {/* Mode Toggle */}
              <div className="flex gap-3">
                <button
                  onClick={() => setKeyGiftMode("give")}
                  className={`px-5 py-2 rounded-lg font-medium transition-all ${
                    keyGiftMode === "give"
                      ? "bg-green-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                >
                  Give Keys
                </button>
                <button
                  onClick={() => setKeyGiftMode("revoke")}
                  className={`px-5 py-2 rounded-lg font-medium transition-all ${
                    keyGiftMode === "revoke"
                      ? "bg-red-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                >
                  Revoke Keys
                </button>
              </div>

              {/* User Search */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Select User
                </label>
                {keyGiftSelectedUser ? (
                  <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-3">
                    <div>
                      <span className="font-semibold text-gray-800">
                        {keyGiftSelectedUser.legal_first_name}{" "}
                        {keyGiftSelectedUser.legal_last_name}
                      </span>
                      <span className="text-gray-500 ml-2">
                        ({keyGiftSelectedUser.email_address})
                      </span>
                      <span className="text-gray-400 ml-2 text-sm">
                        ID: {keyGiftSelectedUser.user_id}
                      </span>
                      <span className="ml-3 text-amber-600 font-semibold text-sm">
                        Balance:{" "}
                        {Number(
                          keyGiftSelectedUser.key_balance || 0,
                        ).toLocaleString()}{" "}
                        keys
                      </span>
                    </div>
                    <button
                      onClick={() => {
                        setKeyGiftSelectedUser(null);
                        setKeyGiftUserId("");
                        setKeyGiftEmail("");
                      }}
                      className="text-red-500 hover:text-red-700 font-medium text-sm"
                    >
                      Change
                    </button>
                  </div>
                ) : (
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search by name, email, or user ID..."
                      value={keyGiftUserSearch}
                      onChange={(e) => setKeyGiftUserSearch(e.target.value)}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                    />
                    {keyGiftUserSearch.length >= 2 && (
                      <div className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        {users
                          ?.filter(
                            (u) =>
                              (u.email_address || "")
                                .toLowerCase()
                                .includes(keyGiftUserSearch.toLowerCase()) ||
                              (u.legal_first_name || "")
                                .toLowerCase()
                                .includes(keyGiftUserSearch.toLowerCase()) ||
                              (u.legal_last_name || "")
                                .toLowerCase()
                                .includes(keyGiftUserSearch.toLowerCase()) ||
                              String(u.user_id).includes(keyGiftUserSearch),
                          )
                          .slice(0, 10)
                          .map((u) => (
                            <button
                              key={u.user_id}
                              onClick={() => handleKeyGiftSelectUser(u)}
                              className="w-full text-left px-4 py-2 hover:bg-amber-50 border-b border-gray-100 last:border-0"
                            >
                              <span className="font-medium text-gray-800">
                                {u.legal_first_name} {u.legal_last_name}
                              </span>
                              <span className="text-gray-500 ml-2 text-sm">
                                ({u.email_address})
                              </span>
                              <span className="text-gray-400 ml-2 text-xs">
                                ID: {u.user_id}
                              </span>
                              <span className="ml-2 text-amber-600 text-xs font-semibold">
                                {Number(u.key_balance || 0).toLocaleString()}{" "}
                                keys
                              </span>
                            </button>
                          ))}
                        {users?.filter(
                          (u) =>
                            (u.email_address || "")
                              .toLowerCase()
                              .includes(keyGiftUserSearch.toLowerCase()) ||
                            (u.legal_first_name || "")
                              .toLowerCase()
                              .includes(keyGiftUserSearch.toLowerCase()) ||
                            (u.legal_last_name || "")
                              .toLowerCase()
                              .includes(keyGiftUserSearch.toLowerCase()) ||
                            String(u.user_id).includes(keyGiftUserSearch),
                        ).length === 0 && (
                          <p className="px-4 py-3 text-gray-500 text-sm">
                            No users found.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Amount */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Number of Keys
                </label>
                <input
                  type="number"
                  min="1"
                  placeholder="e.g. 500"
                  value={keyGiftAmount}
                  onChange={(e) => setKeyGiftAmount(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                />
                {keyGiftAmount && Number(keyGiftAmount) > 0 && (
                  <p className="text-xs text-gray-500 mt-1">
                    ≈ ${(Number(keyGiftAmount) / 500).toFixed(2)} USD value (500
                    keys = $1)
                  </p>
                )}
              </div>

              {/* Reason */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Reason (optional)
                </label>
                <textarea
                  placeholder={
                    keyGiftMode === "give"
                      ? "e.g. Paid in person, promotional bonus, compensation..."
                      : "e.g. Refund error, account adjustment..."
                  }
                  value={keyGiftReason}
                  onChange={(e) => setKeyGiftReason(e.target.value)}
                  rows="2"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                  maxLength={500}
                />
              </div>

              {/* Treasury info */}
              {treasuryStatus && (
                <div className="bg-gray-50 rounded-lg p-3 text-sm text-gray-600">
                  Treasury balance will be{" "}
                  {keyGiftMode === "give" ? "reduced" : "increased"} by{" "}
                  <span className="font-semibold">
                    {Number(keyGiftAmount || 0).toLocaleString()}
                  </span>{" "}
                  keys.
                </div>
              )}

              {/* Submit */}
              <div className="flex gap-3 pt-2">
                <button
                  onClick={handleKeyGiftSubmit}
                  disabled={
                    keyGiftProcessing || !keyGiftUserId || !keyGiftAmount
                  }
                  className={`px-6 py-3 rounded-lg font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed ${
                    keyGiftMode === "give"
                      ? "bg-green-600 text-white hover:bg-green-700"
                      : "bg-red-600 text-white hover:bg-red-700"
                  }`}
                >
                  {keyGiftProcessing
                    ? "Processing..."
                    : keyGiftMode === "give"
                      ? `Give ${keyGiftAmount || 0} Keys`
                      : `Revoke ${keyGiftAmount || 0} Keys`}
                </button>
              </div>
            </div>
          </div>

          {/* Key Gift/Revoke History */}
          <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-800">
                Admin Key Gift/Revoke History
              </h2>
              <button
                onClick={loadKeyGiftHistory}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
              >
                Refresh
              </button>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      ID
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      User ID
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Email
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Type
                    </th>
                    <th className="px-4 py-3 text-right font-semibold text-gray-700">
                      Keys
                    </th>
                    <th className="px-4 py-3 text-left font-semibold text-gray-700">
                      Reason
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {keyGiftHistory.map((entry, index) => (
                    <tr
                      key={entry.transaction_id}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3">{entry.transaction_id}</td>
                      <td className="px-4 py-3">{entry.user_id}</td>
                      <td className="px-4 py-3">{entry.email_address}</td>
                      <td className="px-4 py-3">
                        <span
                          className={`px-2 py-1 rounded text-xs font-medium ${
                            entry.option === "AdminGift"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {entry.option === "AdminGift" ? "Given" : "Revoked"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-right font-semibold">
                        {entry.option === "AdminGift" ? "+" : "-"}
                        {Number(entry.amount || 0).toLocaleString()}
                      </td>
                      <td className="px-4 py-3 text-gray-600 max-w-[300px] break-words">
                        {entry.agent_remarks || "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {keyGiftHistory.length === 0 && (
              <p className="text-center py-8 text-gray-500">
                No admin key gifts or revocations yet.
              </p>
            )}
          </div>
        </div>
      )}

      {/* Agent Remarks Modal */}
      {showRemarksModal && (
        <div>
          <div
            className="fixed inset-0 bg-black/40 z-50"
            onClick={() => setShowRemarksModal(false)}
          />
          <div className="fixed z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-lg bg-white rounded-lg shadow-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Agent Remarks</h3>
              <button
                onClick={() => setShowRemarksModal(false)}
                className="text-sm text-slate-500"
              >
                Close
              </button>
            </div>
            <div className="text-sm text-slate-800 max-h-[60vh] overflow-y-auto whitespace-pre-wrap">
              {remarksContent}
            </div>
          </div>
        </div>
      )}

      {/* User Edit Modal */}
      <AdminUserEditModal
        modal={showUserEditModal}
        setModal={setShowUserEditModal}
        selectedUser={selectedUserForEdit}
        onUpdate={handleUserUpdate}
      />

      {/* Property Edit Modal */}
      {showPropertyEditModal && selectedPropertyForEdit && (
        <ModalEditProperty
          modal={showPropertyEditModal}
          setModal={setShowPropertyEditModal}
          property={selectedPropertyForEdit}
          setProperty={setSelectedPropertyForEdit}
          onPropertyUpdated={handlePropertyUpdate}
        />
      )}

      {/* Admin Create Advertisement Modal */}
      {showAdCreateModal && (
        <AdminAdCreate
          onSuccess={() => {
            getAllAdvertisements().then((data) => {
              setAdvertisements(Array.isArray(data) ? data : []);
            });
          }}
          onClose={() => setShowAdCreateModal(false)}
        />
      )}

      {/* Reported Comments Tab */}
      {activeTab === "comments" && (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="flex flex-wrap justify-between items-center gap-3 p-4 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-800">
              Reported Comments
            </h2>
            <div className="flex flex-wrap gap-2">
              {/* Clear Orphaned Reports button */}
              <button
                onClick={async () => {
                  if (
                    window.confirm(
                      "Clear all reports for comments that no longer exist?",
                    )
                  ) {
                    const result = await commentClearOrphaned();
                    if (result?.success) {
                      setAlert([
                        "Orphaned reports cleared",
                        `${
                          result.deleted_count || 0
                        } orphaned report(s) removed.`,
                        "confirm",
                      ]);
                      commentReportedGet().then((data) => {
                        setReportedComments(data);
                        setSelectedReports([]);
                      });
                    } else {
                      setAlert([
                        "Failed",
                        result?.error || "Could not clear orphaned reports.",
                        "failed",
                      ]);
                    }
                  }
                }}
                className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-all text-sm"
              >
                Clear Orphaned
              </button>
              {/* Approve Selected button */}
              {selectedReports.length > 0 && (
                <button
                  onClick={async () => {
                    if (
                      window.confirm(
                        `Approve ${selectedReports.length} selected report(s)?`,
                      )
                    ) {
                      const result = await commentApproveBulk(selectedReports);
                      if (result?.success) {
                        setAlert([
                          "Reports approved",
                          `${
                            result.updated_count || selectedReports.length
                          } report(s) resolved.`,
                          "confirm",
                        ]);
                        commentReportedGet().then((data) => {
                          setReportedComments(data);
                          setSelectedReports([]);
                        });
                      } else {
                        setAlert([
                          "Failed",
                          result?.error || "Could not approve reports.",
                          "failed",
                        ]);
                      }
                    }
                  }}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-all text-sm"
                >
                  Approve Selected ({selectedReports.length})
                </button>
              )}
              <button
                onClick={() => {
                  commentReportedGet().then((data) => {
                    setReportedComments(data);
                    setSelectedReports([]);
                  });
                  setTimeout(
                    () =>
                      setAlert([
                        "Comments refreshed",
                        "Data has been updated.",
                        "confirm",
                      ]),
                    300,
                  );
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all text-sm"
              >
                Refresh
              </button>
            </div>
          </div>

          {!reportedComments || reportedComments.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              No reported comments at this time.
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase w-10">
                      <input
                        type="checkbox"
                        checked={
                          reportedComments.length > 0 &&
                          selectedReports.length === reportedComments.length
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedReports(
                              reportedComments.map((r) => r.report_id),
                            );
                          } else {
                            setSelectedReports([]);
                          }
                        }}
                        className="w-4 h-4 rounded border-gray-300"
                        title="Select all"
                      />
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      User
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Comment
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Property
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Reported By
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Reason
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {reportedComments.map((report) => (
                    <tr
                      key={report.report_id}
                      className={`hover:bg-gray-50 transition-colors ${
                        !report.comment_text ? "bg-yellow-50" : ""
                      } ${
                        selectedReports.includes(report.report_id)
                          ? "bg-blue-50"
                          : ""
                      }`}
                    >
                      <td className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={selectedReports.includes(report.report_id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedReports([
                                ...selectedReports,
                                report.report_id,
                              ]);
                            } else {
                              setSelectedReports(
                                selectedReports.filter(
                                  (id) => id !== report.report_id,
                                ),
                              );
                            }
                          }}
                          className="w-4 h-4 rounded border-gray-300"
                        />
                      </td>
                      <td className="px-4 py-3">
                        {!report.comment_text ? (
                          <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                            Deleted
                          </span>
                        ) : (
                          <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
                            Exists
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-sm font-medium text-gray-900">
                          {report.comment_owner_first || "Unknown"}{" "}
                          {report.comment_owner_last || "User"}
                        </div>
                        <div className="text-xs text-gray-500">
                          @{report.comment_owner_username || "unknown"} (ID:{" "}
                          {report.comment_owner_id || "N/A"})
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-sm text-gray-700 max-w-xs truncate">
                          {report.comment_text || (
                            <span className="italic text-gray-400">
                              (Comment deleted)
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {report.property_id ? (
                          <>
                            <Link
                              to={`/property/${report.property_id}`}
                              className="text-sm text-blue-600 hover:underline"
                            >
                              #{report.property_id}
                            </Link>
                            <div className="text-xs text-gray-500">
                              {report.property_street_number}{" "}
                              {report.property_street_name},{" "}
                              {report.property_city}
                            </div>
                          </>
                        ) : (
                          <span className="text-sm text-gray-400 italic">
                            N/A
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-sm text-gray-700">
                          {report.reporter_first || "Unknown"}{" "}
                          {report.reporter_last || "User"}
                        </div>
                        <div className="text-xs text-gray-500">
                          @{report.reporter_username || "unknown"}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-sm text-gray-700">
                          {report.reason}
                        </div>
                        {report.details && (
                          <div className="text-xs text-gray-500 mt-1">
                            {report.details}
                          </div>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {new Date(report.created_at).toLocaleString()}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex flex-col gap-2">
                          <button
                            onClick={async () => {
                              if (
                                window.confirm(
                                  "Approve this comment (remove report)?",
                                )
                              ) {
                                const result = await commentApprove(
                                  report.report_id,
                                );
                                if (result?.success) {
                                  setAlert([
                                    "Comment approved",
                                    "Report has been resolved.",
                                    "confirm",
                                  ]);
                                  commentReportedGet().then((data) =>
                                    setReportedComments(data),
                                  );
                                } else {
                                  setAlert([
                                    "Failed",
                                    "Could not approve comment.",
                                    "failed",
                                  ]);
                                }
                              }
                            }}
                            className="px-3 py-1 bg-green-600 text-white text-xs rounded hover:bg-green-700 transition-all"
                          >
                            Approve
                          </button>
                          <button
                            onClick={() => {
                              setCommentToDelete(report);
                              setCommentDeleteReason("");
                              setShowCommentDeleteModal(true);
                            }}
                            className="px-3 py-1 bg-red-600 text-white text-xs rounded hover:bg-red-700 transition-all"
                          >
                            Delete Comment
                          </button>
                          <button
                            onClick={() => {
                              setBanningUserId(report.comment_owner_id);
                              setBanningReportId(report.report_id);
                              setBanningUserEmail(null);
                              setBanningUserName(
                                `${report.comment_owner_first} ${report.comment_owner_last}`,
                              );
                              setBanModalSource("comments");
                              setBanReason("");
                            }}
                            className="px-3 py-1 bg-gray-800 text-white text-xs rounded hover:bg-gray-900 transition-all flex items-center gap-1 justify-center"
                          >
                            <FaGavel className="text-xs" />
                            Ban User
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Ban User Modal */}
      {banningUserId && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="w-full max-w-3xl grid grid-cols-1 lg:grid-cols-2 shadow-2xl rounded-2xl overflow-hidden border border-red-200 bg-white">
            {/* Left side - Warning */}
            <div className="bg-gradient-to-br from-red-700 via-red-600 to-red-500 text-white p-10 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <FaGavel className="text-5xl" />
                  <div>
                    <p className="text-sm uppercase tracking-[0.2em] text-red-100">
                      WARNING
                    </p>
                    <h1 className="text-3xl font-bold leading-tight">
                      Ban User
                    </h1>
                  </div>
                </div>
                <div className="mt-6 space-y-3 text-red-50">
                  <p className="font-semibold text-lg">
                    This action will permanently:
                  </p>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-start gap-2">
                      <span className="text-red-200 font-bold">•</span>
                      <span>
                        <strong>Ban the user account</strong> and prevent login
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-red-200 font-bold">•</span>
                      <span>
                        <strong>Delete all their properties</strong> from the
                        database
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-red-200 font-bold">•</span>
                      <span>
                        <strong>Delete all their comments</strong> across all
                        properties
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-red-200 font-bold">•</span>
                      <span>
                        <strong>Remove all associated data</strong> from the
                        system
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="mt-6 bg-red-900/60 border border-white/30 rounded-xl p-4">
                <p className="text-xs text-red-100 leading-relaxed">
                  <strong>Note:</strong> The user will receive an email
                  notification with your stated reason for the ban. This action
                  cannot be undone.
                </p>
              </div>
            </div>

            {/* Right side - Form */}
            <div className="p-10 bg-white">
              <div className="mb-6">
                <h2 className="text-2xl font-semibold text-slate-900">
                  Confirm Ban Action
                </h2>
                <p className="text-sm text-slate-600 mt-1">
                  {banningUserName && (
                    <>
                      User: <strong>{banningUserName}</strong>
                    </>
                  )}
                </p>
                <p className="text-sm text-slate-500">
                  {banningUserEmail && (
                    <>
                      Email: <strong>{banningUserEmail}</strong>
                    </>
                  )}
                </p>
                <p className="text-sm text-slate-500">
                  User ID: <strong>#{banningUserId}</strong>
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex flex-col gap-2">
                  <label className="text-sm font-semibold text-slate-700">
                    Reason for Ban{" "}
                    <span className="text-red-600 font-bold">*</span>
                  </label>
                  <textarea
                    className="w-full border-2 border-slate-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all resize-none"
                    rows="5"
                    placeholder="Provide a detailed reason for banning this user. This will be included in the notification email sent to the user."
                    value={banReason}
                    onChange={(e) => setBanReason(e.target.value)}
                    maxLength={500}
                  />
                  <p className="text-xs text-slate-500 text-right">
                    {banReason.length}/500 characters
                  </p>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setBanningUserId(null);
                      setBanningReportId(null);
                      setBanningUserEmail(null);
                      setBanningUserName(null);
                      setBanModalSource(null);
                      setBanReason("");
                    }}
                    className="flex-1 px-6 py-3 bg-slate-200 text-slate-700 font-semibold rounded-xl hover:bg-slate-300 transition-all"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={async () => {
                      if (!banReason || banReason.trim().length === 0) {
                        setAlert([
                          "Ban reason required",
                          "Please provide a reason for banning this user.",
                          "failed",
                        ]);
                        return;
                      }

                      setAlert([
                        "Processing ban...",
                        "Please wait while we process this action.",
                        "waiting",
                      ]);

                      let result;
                      if (banModalSource === "users") {
                        // Ban from users tab - delete user account
                        result = await userDelete(
                          banningUserId,
                          banningUserEmail,
                          { setPending },
                          banReason.trim(),
                        );
                      } else {
                        // Ban from comments tab - use comment ban endpoint
                        result = await userBan(
                          banningUserId,
                          banReason.trim(),
                          banningReportId,
                        );
                      }

                      if (result?.success || result?.success !== false) {
                        setAlert([
                          "User banned successfully",
                          "The user has been banned and all their data has been deleted.",
                          "confirm",
                        ]);
                        setBanningUserId(null);
                        setBanningReportId(null);
                        setBanningUserEmail(null);
                        setBanningUserName(null);
                        setBanModalSource(null);
                        setBanReason("");

                        // Refresh data
                        if (banModalSource === "users") {
                          allUsers(setUsers);
                        } else {
                          commentReportedGet().then((data) =>
                            setReportedComments(data),
                          );
                        }
                      } else {
                        setAlert([
                          "Ban failed",
                          result?.error ||
                            "Could not ban user. Please try again.",
                          "failed",
                        ]);
                      }
                    }}
                    disabled={!banReason || banReason.trim().length === 0}
                    className="flex-1 px-6 py-3 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    <FaGavel className="text-lg" />
                    Confirm Ban
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteConfirmModal && propertyToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Confirm Property Deletion
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                You are about to delete property{" "}
                <strong>#{propertyToDelete.property_id}</strong>:
              </p>
              <p className="text-gray-600 mb-2">
                <strong>
                  {propertyToDelete.street_number}{" "}
                  {propertyToDelete.street_name}, {propertyToDelete.city}
                </strong>
              </p>
              <p className="text-gray-600 mb-4">
                Owner: <strong>User #{propertyToDelete.user_id}</strong>
              </p>
              <div className="bg-yellow-50 border border-yellow-200 rounded p-3 mb-4">
                <p className="text-yellow-800 text-sm">
                  ⚠️ This property belongs to another user. The owner will
                  receive an email notification with your reason for deletion.
                  {ENABLE_KEYS &&
                    " Any keys associated with this property will be returned to the Treasury."}
                </p>
              </div>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Reason for Deletion <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
                placeholder="Please provide a detailed reason for deleting this property..."
                value={deleteReason}
                onChange={(e) => setDeleteReason(e.target.value)}
              />
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setPropertyToDelete(null);
                  setDeleteReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteWithReason}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium"
              >
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Comment Delete Modal */}
      {showCommentDeleteModal && commentToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-xl font-bold text-red-600 mb-4">
              Delete Comment
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                Comment by{" "}
                <strong>
                  {commentToDelete.comment_owner_first || "Unknown"}{" "}
                  {commentToDelete.comment_owner_last || "User"}
                </strong>{" "}
                (@{commentToDelete.comment_owner_username || "unknown"})
              </p>
              <div className="bg-gray-100 p-3 rounded border mb-3 max-h-32 overflow-y-auto">
                <p className="text-sm text-gray-700">
                  "
                  {commentToDelete.comment_text || "(Comment text unavailable)"}
                  "
                </p>
              </div>
              <p className="text-sm text-gray-500">
                On property #{commentToDelete.property_id || "N/A"}
              </p>
              {!commentToDelete.comment_text && (
                <p className="text-sm text-yellow-600 mt-2">
                  ⚠️ This comment may have already been deleted. Deleting will
                  remove the report.
                </p>
              )}
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Reason for Deletion <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                rows="4"
                placeholder="Please provide a reason for deleting this comment..."
                value={commentDeleteReason}
                onChange={(e) => setCommentDeleteReason(e.target.value)}
                maxLength={500}
              />
              <p className="text-xs text-gray-500 text-right mt-1">
                {commentDeleteReason.length}/500 characters
              </p>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowCommentDeleteModal(false);
                  setCommentToDelete(null);
                  setCommentDeleteReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  if (!commentDeleteReason.trim()) {
                    setAlert([
                      "Reason required",
                      "Please provide a reason for deleting this comment.",
                      "failed",
                    ]);
                    return;
                  }
                  const result = await commentDeleteAdmin(
                    commentToDelete.comment_id,
                  );
                  if (result?.success === true) {
                    setAlert([
                      "Comment deleted",
                      `Comment has been removed. Reason: ${commentDeleteReason.trim()}`,
                      "confirm",
                    ]);
                    commentReportedGet().then((data) =>
                      setReportedComments(data),
                    );
                    setShowCommentDeleteModal(false);
                    setCommentToDelete(null);
                    setCommentDeleteReason("");
                  } else {
                    setAlert([
                      "Failed",
                      result?.error || "Could not delete comment.",
                      "failed",
                    ]);
                  }
                }}
                disabled={!commentDeleteReason.trim()}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Delete Comment
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Advertisement Reject Modal */}
      {showAdRejectModal && adToReject && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Reject Advertisement
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                You are about to reject the{" "}
                <strong>{adToReject.alignment}</strong> advertisement from User
                #<strong>{adToReject.user_id}</strong>:
              </p>
              <div className="bg-gray-100 rounded p-3 mb-3">
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Link:</strong> {adToReject.link_url}
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Format:</strong> {adToReject.format_width}x
                  {adToReject.format_height}px
                </p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded p-3 mb-4">
                <p className="text-blue-800 text-sm">
                  ℹ️ The user will receive an email notification with your
                  rejection reason, and <strong>100 keys</strong> will be
                  refunded to their account.
                </p>
              </div>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Rejection Reason <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                rows="4"
                placeholder="Please provide a detailed reason for rejecting this advertisement..."
                value={adRejectReason}
                onChange={(e) => setAdRejectReason(e.target.value)}
                maxLength={500}
              />
              <p className="text-xs text-gray-500 text-right mt-1">
                {adRejectReason.length}/500 characters
              </p>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowAdRejectModal(false);
                  setAdToReject(null);
                  setAdRejectReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectAd}
                disabled={!adRejectReason.trim()}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Reject & Refund
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Profile Promotion Reject Modal */}
      {showPromotionRejectModal && promotionToReject && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Reject Profile Promotion
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                You are about to reject the profile promotion from{" "}
                <strong>
                  {promotionToReject.legal_first_name}{" "}
                  {promotionToReject.legal_last_name}
                </strong>
                (User #{promotionToReject.user_id}):
              </p>
              <div className="bg-gray-100 rounded p-3 mb-3">
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Company:</strong>{" "}
                  {promotionToReject.business_name || "N/A"}
                </p>
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Position:</strong>{" "}
                  {promotionToReject.position || "N/A"}
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Impressions Limit:</strong>{" "}
                  {promotionToReject.impressions_limit}
                </p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded p-3 mb-4">
                <p className="text-blue-800 text-sm">
                  ℹ️ The user will receive an email notification with your
                  rejection reason, and <strong>250 keys</strong> will be
                  refunded to their account.
                </p>
              </div>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Rejection Reason <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                rows="4"
                placeholder="Please provide a detailed reason for rejecting this promotion..."
                value={promotionRejectReason}
                onChange={(e) => setPromotionRejectReason(e.target.value)}
                maxLength={500}
              />
              <p className="text-xs text-gray-500 text-right mt-1">
                {promotionRejectReason.length}/500 characters
              </p>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowPromotionRejectModal(false);
                  setPromotionToReject(null);
                  setPromotionRejectReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectPromotion}
                disabled={!promotionRejectReason.trim()}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Reject & Refund
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Admin Create Promotion Modal */}
      {showPromotionCreateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-green-700 mb-4">
              Add Profile Promotion
            </h2>
            <p className="text-sm text-gray-500 mb-4">
              Create an active promotion directly — no keys deducted from the
              user.
            </p>

            {/* User Search */}
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Search User
              </label>
              <input
                type="text"
                value={promotionUserSearch}
                onChange={(e) => {
                  setPromotionUserSearch(e.target.value);
                  setPromotionSelectedUser(null);
                }}
                placeholder="Search by name, email, or ID..."
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              {promotionUserSearch.length >= 2 && !promotionSelectedUser && (
                <div className="mt-1 max-h-48 overflow-y-auto border border-gray-200 rounded bg-white shadow-sm">
                  {users
                    ?.filter((u) => {
                      const q = promotionUserSearch.toLowerCase();
                      return (
                        u.legal_first_name?.toLowerCase().includes(q) ||
                        u.legal_last_name?.toLowerCase().includes(q) ||
                        u.email_address?.toLowerCase().includes(q) ||
                        u.business_name?.toLowerCase().includes(q) ||
                        String(u.user_id).includes(q)
                      );
                    })
                    .slice(0, 10)
                    .map((u) => (
                      <button
                        key={u.user_id}
                        type="button"
                        onClick={() => {
                          setPromotionSelectedUser(u);
                          setPromotionUserSearch(
                            `${u.legal_first_name} ${u.legal_last_name} (#${u.user_id})`,
                          );
                        }}
                        className="w-full text-left px-3 py-2 hover:bg-green-50 border-b border-gray-100 last:border-b-0"
                      >
                        <div className="font-medium text-sm">
                          {u.legal_first_name} {u.legal_last_name}
                          <span className="text-gray-400 ml-2 text-xs">
                            #{u.user_id}
                          </span>
                        </div>
                        <div className="text-xs text-gray-500">
                          {u.email_address} · {u.business_name || "No company"}
                        </div>
                      </button>
                    ))}
                  {users?.filter((u) => {
                    const q = promotionUserSearch.toLowerCase();
                    return (
                      u.legal_first_name?.toLowerCase().includes(q) ||
                      u.legal_last_name?.toLowerCase().includes(q) ||
                      u.email_address?.toLowerCase().includes(q) ||
                      u.business_name?.toLowerCase().includes(q) ||
                      String(u.user_id).includes(q)
                    );
                  }).length === 0 && (
                    <p className="px-3 py-2 text-sm text-gray-400">
                      No users found
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Selected User Preview */}
            {promotionSelectedUser && (
              <div className="mb-4 bg-green-50 border border-green-200 rounded p-3">
                <p className="text-sm font-medium text-green-800">
                  Selected: {promotionSelectedUser.legal_first_name}{" "}
                  {promotionSelectedUser.legal_last_name}
                </p>
                <p className="text-xs text-green-600">
                  {promotionSelectedUser.email_address} ·{" "}
                  {promotionSelectedUser.business_name || "No company"} ·{" "}
                  {promotionSelectedUser.position || "No position"}
                </p>
              </div>
            )}

            {/* Impressions Limit */}
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Impressions Limit
              </label>
              <input
                type="number"
                value={promotionImpressions}
                onChange={(e) =>
                  setPromotionImpressions(
                    Math.max(1, parseInt(e.target.value) || 7500),
                  )
                }
                min="1"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <p className="text-xs text-gray-500 mt-1">
                Default: 7,500 impressions
              </p>
            </div>

            {/* Actions */}
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowPromotionCreateModal(false);
                  setPromotionSelectedUser(null);
                  setPromotionUserSearch("");
                  setPromotionImpressions(7500);
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleAdminCreatePromotion}
                disabled={!promotionSelectedUser || promotionCreating}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {promotionCreating ? "Creating..." : "Create Promotion"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Admin Delete Ad Modal */}
      {showAdDeleteModal && adToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Delete Advertisement
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                You are about to <strong>permanently delete</strong> the{" "}
                <strong>{adToDelete.alignment}</strong> advertisement (ID #
                {adToDelete.advertisement_id}) from User #
                <strong>{adToDelete.user_id}</strong>.
              </p>
              <div className="bg-gray-100 rounded p-3 mb-3">
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Status:</strong> {adToDelete.advertisement_status}
                </p>
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Link:</strong> {adToDelete.link_url}
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Format:</strong> {adToDelete.format_width}x
                  {adToDelete.format_height}px
                </p>
              </div>
              <div className="bg-red-50 border border-red-200 rounded p-3 mb-4">
                <p className="text-red-800 text-sm">
                  ⚠️ This action is <strong>permanent</strong> and cannot be
                  undone. The ad owner will be notified via email.
                </p>
              </div>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Deletion Reason <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                rows="3"
                placeholder="Provide a reason for deleting this ad..."
                value={adDeleteReason}
                onChange={(e) => setAdDeleteReason(e.target.value)}
                maxLength={500}
              />
              <p className="text-xs text-gray-500 text-right mt-1">
                {adDeleteReason.length}/500
              </p>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowAdDeleteModal(false);
                  setAdToDelete(null);
                  setAdDeleteReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleAdminDeleteAd}
                disabled={!adDeleteReason.trim()}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Delete Permanently
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Admin Edit Ad Modal */}
      {showAdEditModal && adToEdit && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-blue-600 mb-4">
              Edit Advertisement
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                Editing <strong>{adToEdit.alignment}</strong> ad (ID #
                {adToEdit.advertisement_id}) — {adToEdit.format_width}x
                {adToEdit.format_height}px
              </p>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 font-medium mb-2">
                Image URL (Cloudinary)
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                value={adEditImageUrl}
                onChange={(e) => setAdEditImageUrl(e.target.value)}
                placeholder="Enter new image URL or keep existing..."
              />
              {adEditImageUrl && (
                <div className="mt-2 border rounded p-2 bg-gray-50">
                  <img
                    src={
                      adEditImageUrl.startsWith("http")
                        ? adEditImageUrl
                        : `https://res.cloudinary.com/dlmkue77e/image/upload/${adEditImageUrl}`
                    }
                    alt="Preview"
                    className="max-h-32 object-contain mx-auto"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              )}
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Link URL
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                value={adEditLinkUrl}
                onChange={(e) => setAdEditLinkUrl(e.target.value)}
                placeholder="Enter the destination URL..."
              />
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowAdEditModal(false);
                  setAdToEdit(null);
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleAdminEditAd}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors font-medium"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Admin Delete Promotion Modal */}
      {showPromoDeleteModal && promoToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4 p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              Delete Promotion
            </h2>
            <div className="mb-4">
              <p className="text-gray-700 mb-2">
                You are about to <strong>permanently delete</strong> the
                promotion for{" "}
                <strong>
                  {promoToDelete.legal_first_name}{" "}
                  {promoToDelete.legal_last_name}
                </strong>{" "}
                (Promo #{promoToDelete.promotion_id}).
              </p>
              <div className="bg-gray-100 rounded p-3 mb-3">
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Status:</strong> {promoToDelete.status}
                </p>
                <p className="text-sm text-gray-700 mb-2">
                  <strong>Company:</strong>{" "}
                  {promoToDelete.business_name || "N/A"}
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Impressions:</strong>{" "}
                  {promoToDelete.impressions_current}/
                  {promoToDelete.impressions_limit}
                </p>
              </div>
              <div className="bg-red-50 border border-red-200 rounded p-3 mb-4">
                <p className="text-red-800 text-sm">
                  ⚠️ This action is <strong>permanent</strong> and cannot be
                  undone. The user will be notified via email.
                </p>
              </div>
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 font-medium mb-2">
                Deletion Reason <span className="text-red-500">*</span>
              </label>
              <textarea
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500"
                rows="3"
                placeholder="Provide a reason for deleting this promotion..."
                value={promoDeleteReason}
                onChange={(e) => setPromoDeleteReason(e.target.value)}
                maxLength={500}
              />
              <p className="text-xs text-gray-500 text-right mt-1">
                {promoDeleteReason.length}/500
              </p>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowPromoDeleteModal(false);
                  setPromoToDelete(null);
                  setPromoDeleteReason("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors font-medium"
              >
                Cancel
              </button>
              <button
                onClick={handleAdminDeletePromotion}
                disabled={!promoDeleteReason.trim()}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Delete Permanently
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
